'use client'

import { useEffect } from 'react'
import { preloadErrorReporting } from './report'

/**
 * Mounted on the pages where visitors DO things (`/app/*`, `/admin/*`,
 * `/batch-transcription`) to pull the dormant Sentry SDK in on arrival, so an
 * error there carries the breadcrumbs that led to it instead of landing bare.
 *
 * Renders nothing. Marketing routes deliberately do NOT mount it — see
 * `preloadErrorReporting`.
 *
 * No "already preloaded" ref guards this: an empty dep list already means once
 * per mount, and a ref would turn Strict Mode's mount → unmount → mount into a
 * SILENT no-op — the cleanup cancels the first attempt and the guard blocks the
 * second, which is the failure mode this component exists to prevent. Calling
 * `forceLoad` twice is free; never calling it is not.
 */
export function ErrorReportingPreload() {
  useEffect(() => preloadErrorReporting(), [])

  return null
}
